var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:[
    _vm.$style.badge,
    _vm.props.disabled && _vm.$style.disabled
  ]},[_vm._v(" "+_vm._s(_vm.props.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }